import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";

export default function AdminConfig() {
  const [c, setC] = useState(null);

  useEffect(() => { api.get("/config").then((r) => setC(r.data)); }, []);

  const save = async () => {
    try {
      const r = await api.put("/admin/config", {
        default_goat_cost: +c.default_goat_cost,
        default_sheep_cost: +c.default_sheep_cost,
        default_lot_cost: +c.default_lot_cost,
        default_lock_period_days: +c.default_lock_period_days,
        platform_fee_percent: +c.platform_fee_percent,
      });
      setC(r.data);
      toast.success("Saved");
    } catch (_) { toast.error("Failed"); }
  };

  if (!c) return <div className="text-center py-12 text-[#6B5F58]">Loading...</div>;

  return (
    <div className="max-w-2xl">
      <h1 className="font-display text-3xl mb-2">Configuration</h1>
      <p className="text-[#6B5F58] mb-6">Defaults that drive lot pricing and economics.</p>

      <div className="gf-card p-6 space-y-4">
        <Field label="Default goat cost (₹)" value={c.default_goat_cost} onChange={(v) => setC({...c, default_goat_cost: v})} testid="cfg-goat" />
        <Field label="Default sheep cost (₹)" value={c.default_sheep_cost} onChange={(v) => setC({...c, default_sheep_cost: v})} testid="cfg-sheep" />
        <Field label="Default lot cost (₹)" value={c.default_lot_cost} onChange={(v) => setC({...c, default_lot_cost: v})} testid="cfg-lot" />
        <Field label="Default lock period (days)" value={c.default_lock_period_days} onChange={(v) => setC({...c, default_lock_period_days: v})} testid="cfg-lock" />
        <Field label="Platform fee on profit (%)" value={c.platform_fee_percent} onChange={(v) => setC({...c, platform_fee_percent: v})} testid="cfg-fee" />
        <button onClick={save} data-testid="save-config-btn" className="px-5 py-2.5 rounded-xl bg-[#D71921] text-white font-medium">Save changes</button>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, testid }) {
  return (
    <label className="block">
      <span className="text-sm font-medium">{label}</span>
      <input data-testid={testid} type="number" value={value} onChange={(e) => onChange(+e.target.value)}
        className="mt-1 w-full rounded-xl border border-[#E8E0D2] px-3 py-2.5 outline-none focus:border-[#D71921]" />
    </label>
  );
}
